import { DataTable, SkeletonLoader } from 'components';

import { humanReadable } from 'utils';

import columns from './columns';
import {
  IListOneTicketStudiesUiProps,
  ListOneTicketStudy,
} from './ListOneTicketStudies.types';

function TypeBodyTemplate(row: ListOneTicketStudy) {
  return (
    <span
      className={`colored-circle colored-circle--${row.type.toLowerCase()}`}
    >
      {row.type}
    </span>
  );
}

function CreatedDateBodyTemplate(row: ListOneTicketStudy) {
  return humanReadable(row.createdDate);
}

export default function ListOneTicketStudies({
  isLoading,
  totalRecords,
  data,
  handlers,
}: IListOneTicketStudiesUiProps) {
  return isLoading ? (
    <SkeletonLoader height="4.4rem" width="8rem" />
  ) : (
    <DataTable
      sortMode="multiple"
      totalRecords={totalRecords}
      value={data.studies}
      onRowClick={handlers.handleRowClick}
      columns={columns.map((column) => {
        if (column.field === 'type') {
          return {
            ...column,
            body: TypeBodyTemplate,
          };
        }

        if (column.field === 'createdDate') {
          return {
            ...column,
            body: CreatedDateBodyTemplate,
          };
        }

        return column;
      })}
    />
  );
}
